module.exports = __webpack_public_path__ + "static/img/empty.9de653e7.png";